export default __webpack_public_path__ + "static/media/verifiedIcon.901b86b8.svg";